import React from "react";
import { inject, observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import Login from "../components/login/Login";

const getLoginRedirectPath = location => {
  const from = location && location.state && location.state.from;

  if (!from || from.pathname === "/login") {
    return "/";
  }

  return `${from.pathname || "/"}${from.search || ""}${from.hash || ""}`;
};

class LoginContainer extends React.Component {
  render() {
    const {
      rootStore: { authStore },
      location
    } = this.props;

    const loginRedirectPath = getLoginRedirectPath(location);

    if (location.pathname === "/login" && authStore.loggedIn) {
      return <Redirect to={loginRedirectPath} />;
    } else {
      return <Login loginRedirectPath={loginRedirectPath} />;
    }
  }
}

export default inject("rootStore")(observer(LoginContainer));
